import React from "react";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ScrollToTop from "react-scroll-to-top";

const SozlesmePage = () => {
  return (
    <>
      {/* ScrollToTop */}
      <ScrollToTop smooth color="#37B24D" />

      {/* HeaderOne */}
      <HeaderOne />

      {/* Breadcrumb */}
      <Breadcrumb title={"Sözleşmeler"} />

      {/* Ana İçerik Bölümü */}
      <section className="contracts py-80">
        <div className="container container-lg">
          <div className="row">
            <div className="col-12">
              {/* Sayfa Başlığı */}
              <div className="text-center mb-48">
                <span className="text-main-600 fw-semibold mb-8 d-block">
                  YASAL DÜZENLEMELER
                </span>
                <h2 className="mb-16" style={{ fontSize: '36px', lineHeight: '1.2' }}>
                  Sözleşmeler ve <br />
                  <span className="text-main-600">Koşullar</span>
                  </h2>
                <p className="text-neutral-600 mb-0" style={{ fontSize: '16px', maxWidth: '600px', margin: '0 auto' }}>
                  Gümüş Pestil olarak müşterilerimizle olan ilişkilerimizi şeffaf ve güvenilir bir şekilde yürütmek için 
                  tüm yasal düzenlemelerimizi burada bulabilirsiniz.
                </p>
              </div>

              {/* Sözleşme Kartları */}
              <div className="row gy-4">
                {/* KVKK Kartı */}
                <div className="col-12">
                  <div className="contract-card border border-gray-100 rounded-16 p-32 mb-24 bg-white shadow-sm">
                    <div className="d-flex align-items-center gap-16 mb-24">
                      <div className="w-56 h-56 flex-center rounded-circle bg-main-50 flex-shrink-0">
                        <i className="ph-fill ph-shield-check text-main-600 text-2xl"></i>
                      </div>
                      <div>
                        <h4 className="mb-4 text-gray-900">Kişisel Verilerin Korunması Hakkında Açıklama</h4>
                        <p className="text-gray-600 mb-0">KVKK kapsamında kişisel verilerin korunması ve işlenmesi</p>
                      </div>
                    </div>
                    
                    <div className="contract-content">
                      <div className="bg-gray-50 rounded-12 p-24">
                        <h5 className="mb-16 text-gray-900">KİŞİSEL VERİLERİN KORUNMASI HAKKINDA AÇIKLAMA VE GİZLİLİK POLİTİKASI</h5>
                        <p className="text-gray-700 mb-16">
                          Kişisel verilerin korunması konusunda ki temel bilgilere aşağıda yer verilmiştir. 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") m. 10'dan doğan aydınlatma yükümlülüğünü yerine getirmek amacıyla aşağıdaki açıklamaları müşterilerimizin ve web-sitemizi ve/veya mobil uygulamalarımızı kullanan 3. kişilerin dikkatine sunar. İşbu Kişisel Verilerin Korunması Hakkında Açıklama metnini yürürlükteki mevzuatta yapılabilecek değişiklikler çerçevesinde her zaman güncelleme hakkını saklı tutar.
                        </p>
                        
                        <div className="mb-16">
                          <h6 className="mb-8 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-scale text-main-600"></i>
                            1) Kişisel verileri toplamasının yasal dayanağı nedir?
                          </h6>
                          <div className="bg-white rounded-12 p-20 border border-gray-100">
                            <p className="text-gray-700 mb-12">
                              Müşterilerimizin kişisel verilerinin kullanılması konusunda çeşitli kanunlarda düzenlemeler bulunmaktadır. En başta KVKK ile kişisel verilerin korunması esasları belirlenmiştir. Ayrıca 6563 Sayılı Elektronik Ticaretin Düzenlenmesi Hakkında Kanun da kişisel verilerin korunmasına ilişkin hüküm içermektedir. 5237 Sayılı Türk Ceza Kanunu hükümleri yoluyla da kişisel verilerin korunması için bazı hallerde cezai yaptırımlar öngörülmüştür.
                            </p>
                            <p className="text-gray-700 mb-0">
                              Diğer yandan, 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği'nden doğan yükümlülüklerimizin ifası amacıyla verilerin toplanması ve kullanılması gerekmektedir.
                            </p>
                          </div>
                        </div>
                        
                        <div className="mb-16">
                          <h6 className="mb-8 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-database text-main-600"></i>
                            2) Kişisel verilerin toplanmasında hangi yöntemleri kullanıyor?
                          </h6>
                          <div className="bg-white rounded-12 p-20 border border-gray-100">
                            <p className="text-gray-700 mb-12">
                              İlgili e-ticaret internet sitesi web sitesinden veya mobil uygulamalardan işlem yapan müşterilerimizin verdikleri veriler, müşterilerimizin rızaları ve mevzuat hükümleri uyarınca ilgili e-ticaret internet sitesi tarafından işlenmektedir.
                            </p>
                            <p className="text-gray-700 mb-12">
                              E-ticaret internet sitesi çerez (cookie) kullanan bir sitedir. çerez; kullanılmakta olan cihazın internet tarayıcısına ya da sabit diskine depolanarak söz konusu cihazın tespit edilmesine olanak tanıyan, çoğunlukla harf ve sayılardan oluşan bir dosyadır.
                            </p>
                            <p className="text-gray-700 mb-0">
                              E-ticaret internet sitesi ziyaretçilerine daha iyi hizmet verebilmek amacıyla ve yasal yükümlülüğü çerçevesinde, işbu Kişisel Verilerin Korunması Hakkında Açıklama metninde belirlenen amaçlar ve kapsam dışında kullanılmamak kaydı ile gezinme bilgilerinizi toplayacak, işleyecek, üçüncü kişilerle paylaşacak ve güvenli olarak saklayacaktır.
                            </p>
                          </div>
                        </div>
                        
                        <div className="mb-16">
                          <h6 className="mb-8 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-target text-main-600"></i>
                            3) Kişisel verileri hangi amaçlarla kullanıyor?
                          </h6>
                          <div className="bg-white rounded-12 p-20 border border-gray-100">
                            <p className="text-gray-700 mb-12">
                              İlgili e-ticaret internet sitesi mevzuatın izin verdiği durumlarda ve ölçüde kişisel bilgilerinizi kaydedebilecek, saklayabilecek, güncelleyebilecek, üçüncü kişilere açıklayabilecek, devredebilecek, sınıflandırabilecek ve işleyebilecektir.
                            </p>
                            <p className="text-gray-700 mb-8">Kişisel verileriniz şu amaçlarla kullanılmaktadır:</p>
                            <ul className="text-gray-700">
                              <li className="mb-4">Web sitesi/mobil uygulamalar üzerinden alışveriş yapanın/yaptıranın kimlik bilgilerini teyit etmek,</li>
                              <li className="mb-4">İletişim için adres ve diğer gerekli bilgileri kaydetmek,</li>
                              <li className="mb-4">Mesafeli satış sözleşmesi ve Tüketicinin Korunması Hakkında Kanun'un ilgili maddeleri tahtında akdettiğimiz sözleşmelerin koşulları, güncel durumu ve güncellemeler ile ilgili müşterilerimiz ile iletişime geçmek, gerekli bilgilendirmeleri yapabilmek,</li>
                              <li className="mb-4">Elektronik (internet/mobil vs.) veya kağıt ortamında işleme dayanak olacak tüm kayıt ve belgeleri düzenlemek,</li>
                              <li className="mb-4">Müşterilerimize daha iyi bir alışveriş deneyimini sağlamak, "müşterilerimizin ilgi alanlarını dikkate alarak" müşterilerimizin ilgilenebileceği ürünlerimiz hakkında müşterilerimize bilgi verebilmek, kampanyaları aktarmak,</li>
                              <li className="mb-0">Yasal yükümlülüklerimizi yerine getirebilmek ve yürürlükteki mevzuattan doğan haklarımızı kullanabilmek,</li>
                            </ul>
                          </div>
                        </div>
                        
                        <div className="mb-16">
                          <h6 className="mb-8 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-shield text-main-600"></i>
                            4) Kişisel verilerinizi nasıl koruyor?
                          </h6>
                          <div className="bg-white rounded-12 p-20 border border-gray-100">
                            <p className="text-gray-700 mb-0">
                              İlgili e-ticaret internet sitesi ile paylaşılan kişisel veriler, İlgili e-ticaret internet sitesi gözetimi ve kontrolü altındadır. İlgili e-ticaret internet sitesi, yürürlükteki ilgili mevzuat hükümleri gereğince bilginin gizliliğinin ve bütünlüğünün korunması amacıyla gerekli organizasyonu kurmak ve teknik önlemleri almak ve uyarlamak konusunda veri sorumlusu sıfatıyla sorumluluğu üstlenmiştir.
                            </p>
                          </div>
                        </div>
                        
                        <div className="mb-16">
                          <h6 className="mb-8 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-users text-main-600"></i>
                            5) Kişisel verilerinizi paylaşıyor mu?
                          </h6>
                          <div className="bg-white rounded-12 p-20 border border-gray-100">
                            <p className="text-gray-700 mb-12">
                              Müşterilerimize ait kişisel verilerin üçüncü kişiler ile paylaşımı, müşterilerin izni çerçevesinde gerçekleşmekte ve kural olarak müşterimizin onayı olmaksızın kişisel verileri üçüncü kişilere aktarılmamaktadır.
                            </p>
                            <p className="text-gray-700 mb-0">
                              Bununla birlikte, yasal yükümlülüklerimiz nedeniyle ve bunlarla sınırlı olmak üzere mahkemeler ve diğer kamu kurumları ile kişisel veriler paylaşılmaktadır. Ayrıca, taahhüt ettiğimiz hizmetleri sağlayabilmek ve verilen hizmetlerin kalite kontrolünü yapabilmek için anlaşmalı üçüncü kişilere kişisel veri aktarımı yapılmaktadır.
                            </p>
                          </div>
                        </div>
                        
                        <div className="mb-0">
                          <h6 className="mb-8 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-article text-main-600"></i>
                            6) KVKK'dan doğan haklarınız nelerdir?
                          </h6>
                          <div className="bg-white rounded-12 p-20 border border-gray-100">
                            <p className="text-gray-700 mb-8">KVKK uyarınca kişisel verilerinizin;</p>
                            <ol className="text-gray-700">
                              <li className="mb-4">İşlenip işlenmediğini öğrenme,</li>
                              <li className="mb-4">İşlenmişse bilgi talep etme,</li>
                              <li className="mb-4">İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme,</li>
                              <li className="mb-4">Yurt içinde / yurt dışında aktarıldığı 3. kişileri bilme,</li>
                              <li className="mb-4">Eksik / yanlış işlenmişse düzeltilmesini isteme,</li>
                              <li className="mb-4">KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini / yok edilmesini isteme,</li>
                              <li className="mb-4">Aktarıldığı 3. kişilere yukarıda sayılan bentleri uyarınca yapılan işlemlerin bildirilmesini isteme,</li>
                              <li className="mb-4">Münhasıran otomatik sistemler ile analiz edilmesi nedeniyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme,</li>
                              <li className="mb-0">KVKK'ya aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme haklarına sahip olduğunuzu hatırlatmak isteriz.</li>
                            </ol>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Mesafeli Satış Sözleşmesi Kartı */}
                <div className="col-12">
                  <div className="contract-card border border-gray-100 rounded-16 p-32 mb-24 bg-white shadow-sm">
                    <div className="d-flex align-items-center gap-16 mb-24">
                      <div className="w-56 h-56 flex-center rounded-circle bg-main-50 flex-shrink-0">
                        <i className="ph-fill ph-file-text text-main-600 text-2xl"></i>
                      </div>
                      <div>
                        <h4 className="mb-4 text-gray-900">Mesafeli Satış Sözleşmesi</h4>
                        <p className="text-gray-600 mb-0">Online satış koşulları ve müşteri hakları</p>
                      </div>
                      </div>
                      
                    <div className="contract-content">
                      <div className="bg-gray-50 rounded-12 p-24">
                        <h3 className="text-center mb-32 text-gray-900">MESAFELİ SATIŞ SÖZLEŞMESİ</h3>
                        
                        {/* Satıcı Bilgileri */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-building text-main-600"></i>
                            1. SATICIYA İLİŞKİN BİLGİLER
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <div className="row gy-16">
                              <div className="col-md-4">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-buildings text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Ticari Ünvan</span>
                                    <span className="text-gray-900">SARAÇ GIDA YAKACAK NAKLİYE OTO ALIM SATIMI KIRTASİYE HAYVAN Limited Şirketi</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-map-pin text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Adres</span>
                                    <span className="text-gray-900">Trabzon Yolu Üzeri İkisu Bedirgan Düzü Mevkii Merkez / GÜMÜŞHANE</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-4">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-phone text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Telefon</span>
                                    <span className="text-gray-900">+90 539 483 8998</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-envelope text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">E-posta</span>
                                    <span className="text-gray-900">fabrika@gumuspestil.com</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-printer text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Faks</span>
                                    <span className="text-gray-500">-</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        {/* Alıcı Bilgileri */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-user text-main-600"></i>
                            2. ALICIYA İLİŞKİN BİLGİLER
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <div className="row gy-16">
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-identification-card text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Ünvanı / Adı Soyadı</span>
                                    <span className="text-gray-500">-</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-map-pin text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Ürün Teslimat Adresi</span>
                                    <span className="text-gray-500">-</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-receipt text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Fatura Teslimat Adresi</span>
                                    <span className="text-gray-500">-</span>
                                  </div>
                                </div>
                              </div>
                              <div className="col-md-6">
                                <div className="d-flex align-items-start gap-12">
                                  <i className="ph ph-phone text-main-600 text-lg flex-shrink-0 mt-2"></i>
                                  <div>
                                    <span className="text-sm fw-semibold text-gray-600 d-block mb-4">Telefon</span>
                                    <span className="text-gray-500">-</span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                      </div>
                        
                        {/* Konu */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-target text-main-600"></i>
                            3. KONU
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-0">
                              İşbu konusu, ALICI' nın SATICI' ya ait +90 539 483 8998 numaralı hat üzerinden ya da www.gumuspestil.com internet sitesinden elektronik ortamda siparişini yaptığı, aşağıda nitelik ve satış fiyatları belirtilen ürün ya da ürünlerin satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicilerin Korunması Hakkındaki Kanun hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.
                            </p>
                          </div>
                        </div>
                        
                        {/* Sözleşme Konusu Ürün */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-package text-main-600"></i>
                            4. SÖZLEŞME KONUSU ÜRÜN
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-0">
                              İşbu kısımda sözleşme konusu ürün ya da ürünlerin cinsi, miktarı, boyu, temel özellikleri, birim fiyatı, satış bedeli ve kargo ücreti gibi bilgiler açıklanmaktadır.
                            </p>
                          </div>
                        </div>
                        
                        {/* Ödeme Şekli */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-credit-card text-main-600"></i>
                            5. ÖDEME ŞEKLİ
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <div className="row gy-16">
                              <div className="col-12">
                                <p className="text-gray-700 mb-16">
                                  Bankanız kampanyalar düzenleyerek sizin seçtiğiniz taksit adedinin daha üstünde bir taksit adedi uygulayabilir, taksit öteleme gibi hizmetler sunalabilir. Bu tür kampanyalar bankanızın inisiyatifindedir ve şirketimizin bilgisi dâhilinde olması durumunda sayfalarımızda kampanyalar hakkında bilgi verilmektedir.
                                </p>
                                <p className="text-gray-700 mb-16">
                                  Havale ile ödemesini yapacağınız siparişlerde 3 iş günü içinde ödemesini yapmadığınız siparişiniz sistem tarafından iptal edilecektir. Bu durumda ortaya çıkacak sorumluluklar müşteriye aittir. Havale işlemini gerçekleştirdikten sonra işleme ait dekont örneğini fabrika@gumuspestil.com e-posta adresine iletiniz veya üye bölümünden "Havale Bildirimi" kısmından bildiriniz.
                                </p>
                                <p className="text-gray-700 mb-0">
                                  Vadeli satışların sadece bankalara ait kredi kartları ile yapılması nedeniyle, ALICI, ilgili faiz oranlarını ve temerrüt faizi ile ilgili bilgileri bankasından ayrıca teyit edeceğini, yürürlükte bulunan mevzuat hükümleri gereğince faiz ve temerrüt faizi ile ilgili yükümlerin Banka ve ALICI arasındaki kredi kartı sözleşmesi kapsamında uygulanacağını kabul, beyan ve taahhüt eder.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        {/* Sevkiyat */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-truck text-main-600"></i>
                            6. SEVKİYAT
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <div className="row gy-16">
                              <div className="col-12">
                                <p className="text-gray-700 mb-16">
                                  Kargo ve teslimat masrafları ALICI'ya aittir. Ürün bedeline dahil değildir. SATICI, web sitesinde, ilan ettiği rakamın üzerinde alışveriş yapanların teslimat ücretinin kendisince karşılanacağını beyan etmişse, teslimat masrafı SATICI'ya aittir. Teslimat, ürün ağırlığına, miktarına, boyutlarına bağlı olarak anlaşmalı kargo şirketleri veya nakliyat firmalarıyla ALICI'nın yukarıda belirtilen 'Ürün Teslimat Adresi'ne teslim edilecektir.
                                </p>
                                <p className="text-gray-700 mb-16">
                                  Mal/hizmetin teslimi ALICI'nın talep ettiği adreste kendisine yapılır. Kendisinden başka birine ve de kendi adresinden başka bir adrese teslimat yapılmasını isterse, bu talebi doğrultusunda teslimat yapılır. Sözleşme konusu ürün, ALICI'dan başka bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun teslimatı kabul etmemesinden SATICI sorumlu tutulamaz.
                                </p>
                                <p className="text-gray-700 mb-0">
                                  Tüketici teslim almadan önce ürünlerin muayenesini yapmalı, ayıplı ve hasarlı malı kargo firması yetkilisinden teslim almamalıdır. ALICI kargodan teslim alınan ürünün sağlam ve hasarsız olduğunu kabul eder.
                                </p>
                              </div>
                            </div>
                          </div>
                      </div>
                        
                        {/* Genel Hükümler */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-scroll text-main-600"></i>
                            7. GENEL HÜKÜMLER
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <div className="row gy-16">
                              <div className="col-12">
                                <div className="mb-16">
                                  <p className="text-gray-700 mb-0">
                                    <strong>7.1.</strong> ALICI, +90 539 483 8998 numaralı hattı arayarak (arama normal tarifeden ücretlendirilir) ya da www.gumuspestil.com internet sitesinde Sözleşme konusu ürünün temel nitelikleri, tüm vergiler dahil satış fiyatı ve ödeme şekli ile teslimata ve bunun masraflarının ALICI tarafından karşılanacağına, teslimatın gerçekleştirileceği süreye ve SATICI'nın tam ticari ünvanı, açık adresi ve iletişim bilgilerine ilişkin ön bilgileri okuyup doğru ve eksiksiz bilgi sahibi olduğunu ve telefon/internet ortamda gerekli teyidi verdiğini beyan eder.
                                  </p>
                                </div>
                                <div className="mb-16">
                                  <p className="text-gray-700 mb-0">
                                    <strong>7.2.</strong> SATICI tarafından daha önce imzalanmış bulunan iş bu iki nüsha Sözleşme ALICI tarafından ............ tarihinde imzalanarak kabul edilmiş ve bir nüshası alıcının mail adresine mail gönderilecektir.
                                  </p>
                                </div>
                                <div className="mb-16">
                                  <p className="text-gray-700 mb-0">
                                    <strong>7.3.</strong> İşbu formda yer alan ürün ya da hizmete ilişkin olarak ALICI' ya sunulan tüm bilgiler ve vaatler ürün bilgilerine ilişkin değişikliklerin yapılması ve yayınlanmasına kadar geçerli olup bu günden sonra SATICI tarafından işbu formda verilen bilgi ve vaatlerle bağlı kalınmadığı ihtar olunur.
                                  </p>
                                </div>
                                <div className="mb-16">
                                  <p className="text-gray-700 mb-0">
                                    <strong>7.4.</strong> SATICI, sözleşme konusu ürünün sağlam, eksiksiz, siparişte belirtilen niteliklere uygun teslim edilmesinden sorumludur.
                                  </p>
                                </div>
                                <div className="mb-16">
                                  <p className="text-gray-700 mb-0">
                                    <strong>7.5.</strong> SATICI, haklı bir nedenle sözleşme konusu mal veya hizmetin tedarik edilemeyeceğinin anlaşılması halinde ALICI' yı bilgilendirip onay alarak, sözleşmeden doğan ifa yükümlülüğünün süresi dolmadan ALICI'ya eşit kalite ve fiyatta farklı bir ürün tedarik edebilir.
                                  </p>
                                </div>
                                <div className="mb-0">
                                  <p className="text-gray-700 mb-0">
                                    <strong>7.6.</strong> SATICI, sipariş konusu ürün veya hizmetin yerine getirilmesinin imkânsızlaşması halinde (stokta bulunmaması, tedarikçi firmadan ürünün hiçbir şekilde tedarik edilememesi durumu) sözleşme konusu yükümlülüklerini yerine getiremezse, bu durumu, sözleşmeden doğan ifa yükümlülüğünün süresi dolmadan tüketiciye bildirererek siparişi iptal edebilir.
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        
                        {/* Teslim Zamanı */}
                        <div className="mb-32">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-clock text-main-600"></i>
                            8. MAL/HİZMETİN TESLİM ZAMANI
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-0">
                              Teslimat, stokun müsait olması ve mal bedelinin SATICI'nın hesabına geçmesinden sonra mümkün olan en kısa sürede yapılır. SATICI, malı/hizmeti siparişinden itibaren 30 (Otuz) gün içinde teslim eder ve bu süre içinde yazılı bildirimle ek 10 (on) günlük süre uzatım hakkini saklı tutar. Doğal afetler, hava muhalefeti vs. gibi mücbir sebeplerle gecikmeler olabilir.
                            </p>
                          </div>
                        </div>
                        
                        {/* Geçerlilik Süresi */}
                        <div className="mb-0">
                          <h5 className="mb-16 text-gray-900 d-flex align-items-center gap-8">
                            <i className="ph ph-calendar text-main-600"></i>
                            9. GEÇERLİLİK SÜRESİ
                          </h5>
                          <div className="bg-white rounded-12 p-24 border border-gray-100">
                            <p className="text-gray-700 mb-16">
                              Listelenen ve siteden ilan edilen fiyatlar satış fiyatıdır. İlan edilen fiyatlar ve vaatler güncelleme yapılana ve değiştirilene kadar geçerlidir. Süreli olarak ilan edilen fiyatlar ise belirtilen süre sonuna kadar geçerliliğini korur. Ancak hatayla yanlış yazılan, tedarikçinin geç bildirmesi ile güncellenmemiş olan fiyat farklılıklarında SATICI'nın müşteriye bildireceği güncel fiyat geçerli kabul edilecektir.
                            </p>
                            <p className="text-gray-700 mb-0">
                              Beşeri/teknik hatalar nedeniyle yanlış fiyatla girilen siparişler yapılacak bilgilendirme sonrasında, iptal edilecektir.
                            </p>
                      </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FooterOne */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default SozlesmePage; 